module.exports = __webpack_public_path__ + "static/media/without-captain.5aa59346.png";